module.exports = __webpack_public_path__ + "assets/RetinaNarr-ExLightItalic.aad5edc6b8abaaed0f5a8ad143c81267.woff2";